// extracted by mini-css-extract-plugin
export default {"section":"ArticlePage_section__te17e"};